import Box from "@/common/components/Box";
import Button from "@/common/components/Button";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { ShowHeader } from "@/common/components/ShowHeader";
import ResumeBox from "@/common/components/ResumeBox";
import { useNavigate, useParams } from "react-router-dom";
import useMaintenanceObjectivePart from "../../hooks/useMaintenanceObjectivePart";
import Badge from "@/common/components/Badge";
import React from "react";
import { ChevronsRightIcon } from "lucide-react";

const MaintenanceObjectivePartsShow = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const {
    data: objectivePart,
    isPending: isObjectivePartPending,
    refetch: refetchObjectivePart,
    error: objectivePartError = {} as any,
  } = useMaintenanceObjectivePart(id);

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-64px)]"
      statusCode={objectivePartError?.status}
      refetchFunction={refetchObjectivePart}
    >
      <div>
        <ShowHeader
          goBack
          goBackProps={{ fallback: `/objective-maintenance/parts` }}
          titleClassName="text-nowrap max-w-56 overflow-hidden text-ellipsis font-normal text-base"
          title="Objetos de manutenção"
          subtitle={(
            <div className="flex items-center gap-2">
              <h2 className="text-white-400">
                Parte
              </h2>

              <ChevronsRightIcon className="text-white-400" />

              <h2 className="text-white-800">
                {objectivePart?.display_name}
              </h2>
            </div>
          )}
          isLoading={isObjectivePartPending}
          buttons={(
            <div className="flex items-center gap-3">
              <Button
                name="update"
                operationKlassToCheckPermission="Admin::Maintenance::ObjectiveParts::Update"
                onClick={() => navigate('edit')}
              >
                Editar
              </Button>
            </div>
          )}
        />

        <Box className="max-h-[calc(100vh-132px)] overflow-y-auto flex flex-col gap-4">
          <p className="text-lg font-medium">
            Dados gerais da parte
          </p>

          <div className="flex items-stretch gap-3">
            <ResumeBox
              boxClassName="flex-1"
              label="Sistema"
              value={(
                <div className="flex gap-2 flex-wrap">
                  {objectivePart?.system_parts.map((system) => (
                    <Badge
                      key={system.id}
                      Icon={React.Fragment}
                      text={system.system.display_name}
                      valueDataTestid="system_part"
                    />
                  ))}
                </div>
              )}
              isLoading={isObjectivePartPending}
            />

            <ResumeBox
              boxClassName="flex-1"
              label="Nome da parte"
              value={objectivePart?.display_name}
              isLoading={isObjectivePartPending}
              testId="display_name"
            />
          </div>
        </Box>
      </div>
    </ErrorMessageWrapper>
  );
}

export default MaintenanceObjectivePartsShow;
